import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { fetchRecords, getRecord, postRecord, resetRecord, getLatestRockMassGroup } from './actions';
import { KansatsuKirokuSubdiv } from '../../../models/KansatsuKirokuSubdiv';
import * as moment from 'moment';

export interface KansatsuKirokuSubdivState {
  loaded: boolean;
  items: KansatsuKirokuSubdiv[];
  item: KansatsuKirokuSubdiv;
  latestRockMassGroup?: string;
}

const initialState: KansatsuKirokuSubdivState = {
  loaded: false,
  items : [],
  item: new KansatsuKirokuSubdiv(),
  latestRockMassGroup: undefined
};

const reducer = reducerWithInitialState(initialState)
  .case(fetchRecords.started, (state) => {
    return { ...initialState };
  })
  .case(fetchRecords.done, (state, param) => {
    // 観察年月日 desc, 測点番号 descでソートする
    param.result.Items.sort((a, b) => {
      const dateA = moment(a.kansatsuDate, 'YYYY-MM-DD');
      const dateB = moment(b.kansatsuDate, 'YYYY-MM-DD');
      // 両方が無効な日付の場合は何もしない
      if (!dateA.isValid() && !dateB.isValid()) {
        return 0;
      }
      // どちらが有効な日付の場合、有効な日付を持つほうが値が大きい扱いにする
      if (dateA.isValid() && !dateB.isValid()) {
        return -1;
      }
      if (!dateA.isValid() && dateB.isValid()) {
        return 1;
      }
      if (dateA.isBefore(dateB)) {
        return 1;
      }
      if (dateA.isAfter(dateB)) {
        return -1;
      }
      // ここに来るときはdateA.isSame(dateB) なので測点番号でソート
      if (a.sokutenNumber < b.sokutenNumber) {
        return 1;
      }
      if (a.sokutenNumber > b.sokutenNumber) {
        return -1;
      }
      // ここまで来たら観察年月日と測点番号が同じ
      return 0;
    });
    return { ...state, loaded: true, items: param.result.Items, item: new KansatsuKirokuSubdiv()};
  })
  .case(fetchRecords.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })
  .case(getRecord.started, (state) => {
    return { ...state, loaded: false, item: new KansatsuKirokuSubdiv() };
  })
  .case(getRecord.done, (state, param) => {
    return { ...state, loaded: true, item: param.result.Item};
  })
  .case(getRecord.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })

  .case(postRecord.done, (state, param) => {
    return { ...state, loaded: true, item: param.result.item};
  })
  .case(postRecord.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })

  .case(resetRecord, (state) => {
    return { ...state, item: initialState.item };
  })

  .case(getLatestRockMassGroup.started, (state) => {
    return { ...state };
  })
  .case(getLatestRockMassGroup.done, (state, payload) => {
    return { ...state, latestRockMassGroup: payload.result.rockMassGroup };
  })
  .case(getLatestRockMassGroup.failed, (state, error) => {
    console.log('reducer getLatestRockMassGroup failed error', error);
    return { ...state };
  })
;

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/kansatsuKirokuSubdiv/reducers.ts